import React from 'react'
import styled from 'styled-components'
import Typography from '@ntuctech/devex-tangram/Typography'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import { CustomPanel } from './elements'
import { SCREEN_SIZE } from '../../../../lib/Media'
import { useRouter } from 'next/router'

const GuideWrapper = styled.div`
  display: flex;
  width: 100%;

  ${SCREEN_SIZE.Below.Tablet} {
    flex-direction: column;
    margin-bottom: 1.5rem;
  }
`

const IndividualWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
const ImgSc = styled.img`
  width: 20.5rem;
  height: 10.25rem;
  align-self: center;
`
const HeaderSc = styled(Typography)`
  margin-top: 1rem;
`
const BrowsewineButtonSc = styled(ButtonContained)`
  margin: 0;
  padding: 0;
  width: 7.5rem;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  cursor: pointer;

  ${SCREEN_SIZE.Below.Tablet} {
    width: 100%;
  }
`

const HowToUsePanel = () => {
  const router = useRouter()

  return (
    <CustomPanel>
      <Typography variant="h4">
        Log in now to start enjoying your benefits:
      </Typography>
      <div style={{ borderBottom: '1px solid #EAEAEA', margin: '1.5rem 0' }} />
      <GuideWrapper>
        <IndividualWrapper>
          <ImgSc src="https://media.nedigital.sg/fairprice/images/272251b5-d1ae-44a3-951e-0ae74757cfd3/Shop_online.jpg"></ImgSc>
          <HeaderSc variant="h5">Shop online</HeaderSc>
          <Typography variant="body2">
            Add Just Wine Club products to your cart on the app or
            www.fairprice.com.sg and enjoy automatic discounts.
          </Typography>
          <BrowsewineButtonSc
            onClick={() => router.push('https://fairprice.com.sg/tag/jwc')}
          >
            Browse wines
          </BrowsewineButtonSc>
        </IndividualWrapper>
        <IndividualWrapper>
          <ImgSc src="https://media.nedigital.sg/fairprice/images/8582c1ca-30f5-48cc-9438-30513d1e82d0/jwc_animation_hr.gif"></ImgSc>
          <HeaderSc variant="h5">Shop in-store</HeaderSc>
          <Typography variant="body2">
            During checkout, tap “Pay/Earn” on the FairPrice Group app to scan
            your app QR and enjoy membership perks.
          </Typography>
        </IndividualWrapper>
      </GuideWrapper>
    </CustomPanel>
  )
}

export default HowToUsePanel
